import { render, staticRenderFns } from "./booth_registration.vue?vue&type=template&id=5c2991c2&scoped=true"
import script from "./booth_registration.vue?vue&type=script&lang=js"
export * from "./booth_registration.vue?vue&type=script&lang=js"
import style0 from "./booth_registration.vue?vue&type=style&index=0&id=5c2991c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2991c2",
  null
  
)

export default component.exports